import adressenGatewayApi from "../../api/shared/adressenGatewayApi";
import mergeDeep from "../../util/mergeDeep";
import generateGuid from "../../util/guid";

export default class AdresWizardHelper {
	constructor(context, redirector, savedModel) {
		this.context = context;
		this.redirector = redirector;
		this.savedModel = savedModel;
	}

	init() {
		this.context.setState({
			model: mergeDeep({}, this.savedModel)
		});
	}

	gemeenteChanged(event) {
		const context = this.context;
		const value = event.target.value;
		const gemeenten = this.context.props.gemeenten;
		const model = this.context.state.model;
		const ajaxActions = this.context.props.ajaxActions;

		const gemeente = gemeenten.find(x => x.value === value);
		if (!gemeente) {
			context.setState({
				straatEnabled: false
			});
		} else{
			model.displayName = gemeente.displayName;
			model.gemeenteNaam = gemeente.hoofdGemeente;
			model.gemeenteKey = gemeente.key;
			model.gemeenteUUId = gemeente.value;
			model.gemeenteId = gemeente.nis;
			model.postcode = gemeente.postCode;
			model.straatNaam = "";
			model.straatId = 0;
			model.huisNummer = "";
			model.busNummer = "";
			model.latitude = 0;
			model.longitude = 0;

			adressenGatewayApi.listStratenByGemeenteIdAndPostcode(gemeente.nis, gemeente.postCode)
				.then((response) => {
					ajaxActions.ended();

					let straten = response.data;
					context.setState({
						straatEnabled: true,
						huisnummerEnabled: false,
						busnummerEnabled: false,
						confirmDisabled: true,
						model,
						straten
					});
				})
				.catch((ex) => {
					ajaxActions.failed();
					context.props.throwException(ex);
				});
		}
	}

	straatChanged(event){
		const context = this.context;
		const value = event.target.value;
		const model = this.context.state.model;
		const ajaxActions = this.context.props.ajaxActions;

		const straat = this.context.state.straten.find(x => x.id === value);

		if (!straat) {
			context.setState({
				huisnummerEnabled: false
			});
		} else{
			model.straatNaam = straat.naam;
			model.straatId = straat.id;
			model.huisNummer = "";
			model.busNummer = "";
			model.latitude = 0;
			model.longitude = 0;

			adressenGatewayApi.listHuisnummers(model.gemeenteId, model.postcode, straat.naam)
				.then((response) => {
					ajaxActions.ended();

					let huisnummers = response.data;
					context.setState({
						huisnummerEnabled: true,
						busnummerEnabled: false,
						confirmDisabled: false,
						model,
						huisnummers
					});
				})
				.catch((ex) => {
					ajaxActions.failed();
					context.props.throwException(ex);
				});
		}
	}

	huisnummerChanged(event){
		const context = this.context;
		const value = event.target.value;
		const model = this.context.state.model;

		const huisnummer = this.context.state.huisnummers.find(x => x.huisnummer === value);

		if (!huisnummer) {
			model.huisNummer = value;
			model.huisnummerId = 0;
			model.busNummer = "";
			model.latitude = 0;
			model.longitude = 0;

			context.setState({
				model,
				busnummerEnabled: false
			});
		} else{
			model.huisNummer = huisnummer.huisnummer;
			model.huisnummerId = huisnummer.id;
			model.busNummer = "";
			model.latitude = 0;
			model.longitude = 0;

			context.setState({
				busnummerEnabled: true,
				confirmDisabled: false,
				model,
				busnummers: huisnummer.busnummers
			});
		}
	}

	busnummerChanged(event){
		const context = this.context;
		const value = event.target.value;
		const model = this.context.state.model;

		const busnummer = this.context.state.busnummers.find(x => x.id === value);

		if (busnummer) {
			model.busNummer = busnummer.busnummer;
			model.busnummerId = busnummer.id;
			model.latitude = 0;
			model.longitude = 0;

			context.setState({
				confirmDisabled: false,
				model,
			});
		} else{
			model.busNummer = value;
			model.busnummerId = busnummer.id;
			model.latitude = 0;
			model.longitude = 0;

			context.setState({
				confirmDisabled: false,
				model,
			});
		}
	}

	openAdresModal(){
		const context = this.context;

		context.setState({
			openModal: true
		});
	}

	closeAdresModal(confirm) {
		if (confirm) {
			this.saveAdres();
		} else {
			this.cancelAdres();
		}
	}

	saveAdres(){
		const context = this.context;
		const model = this.context.state.model;
		const savedAdres = this.context.state.savedAdres;
		const props = this.context.props;
		const ajaxActions = this.context.props.ajaxActions;

		adressenGatewayApi.getCoordinatenForAdres(model.gemeenteNaam, model.postcode, model.straatNaam, model.huisNummer)
			.then((response) => {
				ajaxActions.ended();

				let coordinaten = response.data;
				model.latitude = coordinaten.latitude;
				model.longitude = coordinaten.longitude;

				if (!savedAdres.id)
					savedAdres.id = generateGuid();

				savedAdres.displayName = model.displayName;
				savedAdres.gemeenteId = model.gemeenteId;
				savedAdres.gemeente = model.gemeenteNaam;
				savedAdres.postCode = model.postcode;
				savedAdres.straatId = model.straatId;
				savedAdres.straatNaam = model.straatNaam;
				savedAdres.huisNummer = model.huisNummer;
				savedAdres.busNummer = model.busNummer;
				savedAdres.latitude = model.latitude;
				savedAdres.longitude = model.longitude;

				if (!savedAdres.busNummer)
					savedAdres.adresObjectId = model.huisnummerId;
				else
					savedAdres.adresObjectId = model.busnummerId;

				props.onSave(savedAdres);

				context.setState({
					model,
					savedAdres,
					openModal: false,
					// straatEnabled: false,
					// huisnummerEnabled: false,
					// busnummerEnabled: false,
					// confirmDisabled: true,
				});
			})
			.catch((ex) => {
				ajaxActions.failed();
				context.props.throwException(ex);
			});
	}

	cancelAdres(){
		this.context.setState({
			openModal: false
		});
	}
}
